
export interface SavedCalculation {
    calculationId: number;
    name: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface CalculationCosts {
    notary: number;
    broker: number;
    rentFees: number;
    maintenanceFees: number;
    minProfitPercent: number;
    portalFees: number;
    photographerAmount: number;
    saleBroker: number;
    pcc: number;
    tax: number;
    renovation: number;
    userOption: number;
    sumOfCosts: number;
}

export const initialCalculationCosts: CalculationCosts = {
    notary: 0,
    broker: 0,
    rentFees: 0,
    maintenanceFees: 0,
    portalFees: 0,
    photographerAmount: 0,
    minProfitPercent: 0,
    saleBroker: 0,
    pcc: 0,
    tax: 0,
    renovation: 0,
    userOption: 0,
    sumOfCosts: 0
};

export interface CalculatorModuleState {
    calculationId: number | null;
    calculationName: string;
    savedCalculations: SavedCalculation[];
    currentPrice: number | null;
    certainPrice: number | null;
    area: number | null;
    address: string;
    maxPurchasePrice: number | null;
    profit: number | null;
    margin: number | null;
    costs: CalculationCosts | null;
    flipTime: string;
    minProfitAmount: string;
    minProfitPercent: string;
    notary: string;
    brokerPercent: string;
    rentFees: string;
    maintenanceFees: string;
    portalFees: string;
    photographerAmount: string;
    saleBrokerPercent: string;
    pcc: string;
    tax?: string;
    renovationFrom1To30Amount: string;
    renovationFrom30To40Amount: string;
    renovationFrom40To50Amount: string;
    renovationFrom50To60Amount: string;
    renovationFrom60PlusAmount: string;
    renovationFee: string;
    userOption?: number;
    isLoading: boolean;
}

export interface SaveCalculationRequest {
    filterId?: number | null;
    name: string;
    price: number;
    certainPrice: number;
    area: number;
    address?: string;
    flipTime: string;
    minProfitAmount: string;
    minProfitPercent: string;
    notary: string;
    brokerPercent: string;
    rentFees: string;
    maintenanceFees: string;
    portalFees: string;
    photographerAmount: string;
    saleBrokerPercent: string;
    pcc: string;
    renovation: string;
    userOption?: number;
}

export interface CalculateFlipApiResponse {
    certainPrice: number;
    price: number;
    area: number;
    address?: string;
    filter: {
        flipTime: string;
        minProfitAmount: string;
        minProfitPercent: string;
        notary: string;
        brokerPercent: string;
        rentFees: string;
        maintenanceFees: string;
        portalFees: string;
        photographerAmount: string;
        saleBrokerPercent: string;
        pcc: string;
        renovation: string;
        userOption: number;
    };
    calculation: {
        maxPurchasePrice: number;
        margin: number;
        profit: number;
        realPrice: number;
        costs: CalculationCosts;
    };
}

export interface CalculateFlipResponse {
    maxPurchasePrice: number;
    profit: number;
    margin: number;
    costs: CalculationCosts;
}

export interface GetSavedCalculationsResponse {
    calculations: SavedCalculation[];
}

export interface GetCalculationApiResponse {
    filterId: number;
    name: string;
    price: number;
    certainPrice: number;
    area: number;
    address?: string;
    filter: {
        flipTime: string;
        minProfitAmount: string;
        minProfitPercent: string;
        notary: string;
        brokerPercent: string;
        rentFees: string;
        maintenanceFees: string;
        portalFees: string;
        photographerAmount: string;
        saleBrokerPercent: string;
        pcc: string;
        renovation: string;
        userOption: number;
    };
    calculation: {
        maxPurchasePrice: number;
        profit: number;
        margin: number;
        realPrice: number;
        costs: CalculationCosts;
    };
    createdAt?: string;
    updatedAt?: string;
}

export interface GetCalculationResponse {
    filterId: number;
    name: string;
    price: number;
    realPrice: number;
    certainPrice: number;
    area: number;
    address?: string;
    maxPurchasePrice: number;
    profit: number;
    margin: number;
    costs: CalculationCosts;
    flipTime: string;
    minProfitAmount: string;
    minProfitPercent: string;
    notary: string;
    brokerPercent: string;
    rentFees: string;
    maintenanceFees: string;
    portalFees: string;
    photographerAmount: string;
    saleBrokerPercent: string;
    pcc: string;
    renovation: string;
    userOption: number;
    createdAt?: string;
    updatedAt?: string;
}

export const initialCalculatorModuleState: CalculatorModuleState = {
    flipTime: '',
    minProfitAmount: '',
    minProfitPercent: '',
    notary: '',
    brokerPercent: '',
    rentFees: '',
    maintenanceFees: '',
    portalFees: '',
    photographerAmount: '',
    saleBrokerPercent: '',
    pcc: '',
    tax: '',
    renovationFrom1To30Amount: '',
    renovationFrom30To40Amount: '',
    renovationFrom40To50Amount: '',
    renovationFrom50To60Amount: '',
    renovationFrom60PlusAmount: '',
    renovationFee: '',
    userOption: 0,
    certainPrice: null,
    calculationId: null,
    calculationName: '',
    savedCalculations: [],
    currentPrice: null,
    area: null,
    address: '',
    maxPurchasePrice: null,
    profit: null,
    margin: null,
    costs: null,
    isLoading: false
};
